export default "/images/e5e104e45a62cf0300909ea3f57c6667.avif";